export default {
  list: [],
  dadosBasicos: {
    id: null,
    nome: null,
    email: null,
    idade: null,
    sexo: null,
    telefone: null,
    celular: null,
    cpfCnpj: null,
    cep: null,
    endereco: null,
    cidade: null,
    estado: null,
    pais: null,
    pretencaoSalarial: null,
    skype: null,
    linkedin: null,
    idUsuario: null
  },
  descricao: {
    idUsuario: null,
    descricao: ''
  },
  linguaList: [],
  linguaGroup: [
    {
      language: 'Português',
      libs: [
        { id: null, nome: 'Português', curriculoLinguaNivel: 'BASICO', excluido: false, idUsuario: null },
        { id: null, nome: 'Português', curriculoLinguaNivel: 'INTERMEDIARIO', excluido: false, idUsuario: null },
        { id: null, nome: 'Português', curriculoLinguaNivel: 'AVANCADO', excluido: false, idUsuario: null },
        { id: null, nome: 'Português', curriculoLinguaNivel: 'FLUENTE', excluido: false, idUsuario: null }
      ]
    },
    {
      language: 'Inglês',
      libs: [
        { id: null, nome: 'Inglês', curriculoLinguaNivel: 'BASICO', excluido: false, idUsuario: null },
        { id: null, nome: 'Inglês', curriculoLinguaNivel: 'INTERMEDIARIO', excluido: false, idUsuario: null },
        { id: null, nome: 'Inglês', curriculoLinguaNivel: 'AVANCADO', excluido: false, idUsuario: null },
        { id: null, nome: 'Inglês', curriculoLinguaNivel: 'FLUENTE', excluido: false, idUsuario: null }
      ]
    },
    {
      language: 'Espanhol',
      libs: [
        { id: null, nome: 'Espanhol', curriculoLinguaNivel: 'BASICO', excluido: false, idUsuario: null },
        { id: null, nome: 'Espanhol', curriculoLinguaNivel: 'INTERMEDIARIO', excluido: false, idUsuario: null },
        { id: null, nome: 'Espanhol', curriculoLinguaNivel: 'AVANCADO', excluido: false, idUsuario: null },
        { id: null, nome: 'Espanhol', curriculoLinguaNivel: 'FLUENTE', excluido: false, idUsuario: null }
      ]
    }
  ],
  habilidadeGroup:
  [
    {
      id: null,
      nome: 'Vuejs',
      idUsuario: null,
      excluido: false
    },
    {
      id: null,
      nome: 'Php',
      idUsuario: null,
      excluido: false
    },
    {
      id: null,
      nome: 'Java',
      idUsuario: null,
      excluido: false
    }
  ],
  habilidadeList: [],
  categoriaList: [],
  tipoEmpresa: [],
  ramoAtividade: [],
  formacaoAcademicaList: [],
  historicoProfissionalList: [],
  categoria: {
    id: 0,
    nome: '',
    idUsuario: 0
  },
  certificacaoList: [],
  dadosBasicosValidation: false,
  descricaoValidation: false,
  habilidadeListValidation: false
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/meusCurriculos/store/state.js